'use strict'

module.exports = (function () {
    /**
    * @ngdoc method
    * @name initialize
    * @description initializes accessibilty extensions to bootstrap 3 data-toggle="tab"
    **/

    var initialize = function (selector) {

        const second = 1000,
            minute = second * 60,
            hour = minute * 60,
            day = hour * 24;

        // Get all span elements with the class 'countdown-timer-item'
        const countdownElements = document.querySelectorAll(selector);
        console.info("Countdown Elements? ", countdownElements);
        countdownElements.forEach(function (element) {
            // Get the data-countdown attribute value (which is the target date)
            let countdownDate = element.getAttribute('data-countdown');

            // Convert it into a Date object
            const countDown = new Date(countdownDate).getTime();

            // Set up the interval for each countdown timer
            const x = setInterval(function () {
                const now = new Date().getTime(),
                    distance = countDown - now;

                // Find child spans to update with the remaining time
                const daysSpan = element.querySelector('.days');
                const hoursSpan = element.querySelector('.hours');
                const minutesSpan = element.querySelector('.minutes');
                const secondsSpan = element.querySelector('.seconds');

                if (daysSpan && hoursSpan && minutesSpan && secondsSpan) {
                    // Update the countdown timer display for this element
                    daysSpan.innerText = Math.floor(distance / day);
                    hoursSpan.innerText = Math.floor((distance % day) / hour);
                    minutesSpan.innerText = Math.floor((distance % hour) / minute);
                    secondsSpan.innerText = Math.floor((distance % minute) / second);
                }

                // When the countdown is complete
                if (distance < 0) {
                    clearInterval(x);
                    element.innerHTML = "";
                }
            }, 1000); // Update every second
        });
    };

    // Return an object exposing the public items
    return {
        initialize: initialize
    };
}())